<template>
    <header id="main-header" class="row">
        <div class="col col-12 col-sm col-lg col-xl col-xxl">
            <h1 class="mb-1 mb-sm-2">{{ title }}</h1>
        </div>
        <div class="col mb-2 mb-sm-0 col-12 col-sm col-lg col-xl col-xxl text-sm-right" v-if="renderSideColumn">
            <slot name="buttons"/>
            <buttons v-on:button="$emit('button-' + $event)" :buttons="buttons"/>
        </div>
    </header>
</template>
<script>
    import AcceptAction from '../../core/AcceptAction'
    import Buttons from '../../core/Buttons';

    export default {
        components: {
            Buttons,
            AcceptAction
        },
        computed: {
            renderSideColumn() {
                return this.hasButtons === true || this.buttons.length !== 0;
            },
            hasButtons () {
                return !!this.$slots['buttons']
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            buttons: {
                type: Array,
                'default': function () {
                    return [];
                }
            }
        },
        data() {
            return {
                openedCollapse: false,
            };
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/Layout/TheHeader.vue